module.exports = __webpack_public_path__ + "static/img/empty3.9826cea8.png";